import React from 'react';
import PropTypes from 'prop-types';

const Settlements = ({ theme, fill, ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.9">
      <path
        d="M17.6463 2.38264C16.6326 1.36887 15.3112 0.867676 13.9785 0.867676C12.6572 0.867676 11.3245 1.36887 10.3107 2.38264C9.55892 3.13442 9.05774 4.62661 8.72741 6.2327C8.53376 7.15534 8.39708 8.10077 8.29456 8.96647V8.97785C8.21483 9.6613 8.16926 10.2764 8.13509 10.7776C8.08953 11.4155 8.6135 11.9394 9.25138 11.8939C11.4612 11.7458 16.12 11.2446 17.6463 9.71825C19.6739 7.6907 19.6739 4.41018 17.6463 2.38264ZM15.9377 8.02104C15.9377 8.02104 15.1973 8.71587 11.7801 9.20567C11.4042 9.26262 11.0283 9.30819 10.6752 9.34236C10.7094 8.98925 10.7549 8.61335 10.8119 8.23746C10.9144 7.51984 11.0283 6.91614 11.1422 6.42634C11.5637 4.55826 11.9965 4.09124 12.0079 4.09124C12.5319 3.56727 13.2267 3.2825 13.9671 3.2825C14.7075 3.2825 15.4024 3.56727 15.9263 4.09124C17.0198 5.17336 17.0198 6.92753 15.9377 8.02104Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M11.1537 6.42606C11.0398 6.92725 10.9259 7.51957 10.8234 8.23718C10.7665 8.61308 10.7209 8.98897 10.6867 9.34208C10.6867 9.34208 8.32885 9.77493 8.29468 8.97758V8.96619C8.39719 8.11189 8.53388 7.15507 8.72752 6.23242L11.1537 6.42606Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M19.1609 11.9053V16.7577C19.1609 18.0904 18.0788 19.1725 16.7461 19.1725H16.1196C16.7006 19.1725 16.7461 17.5209 16.7461 16.7577V14.3201C16.7461 13.6594 17.0195 13.0557 17.4523 12.6115C17.8966 12.1787 18.5003 11.9053 19.1609 11.9053Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M8.06619 0.833496C8.06619 2.16621 6.98407 3.24833 5.65136 3.24833H3.23653V3.62422C3.23653 3.62422 3.09984 0.833496 3.85163 0.833496H8.06619Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M16.1196 19.1725H0.833252V3.24833C0.833252 1.91561 1.91536 0.833496 3.24808 0.833496H3.86318C3.11139 0.833496 3.24808 3.62422 3.24808 3.62422V16.7577H16.7575C16.7575 17.5209 16.7005 19.1725 16.1196 19.1725Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
    </g>
  </svg>
);

Settlements.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Settlements;
